import BusinessSearchResultsSkeleton from '@loaders/BusinessSearchResultsSkeleton';
import { memo } from 'react';

import BusinessResultItem from './BusinessResultItem';

const BusinessSearchResults = memo(({ results, onSelect, loading = false, error = '' }) => {
  if (loading) {
    return <BusinessSearchResultsSkeleton />;
  }

  if (error) {
    return <p className="desktop:text-[16px] text-sm font-medium text-error">{error}</p>;
  }

  if (!results.length) {
    return (
      <p className="desktop:text-[16px] text-sm font-medium text-merchant-text-secondary">
        No businesses found. Try a different search.
      </p>
    );
  }

  return (
    <div className="flex w-full flex-col gap-business-results">
      <p className="text-caption font-medium text-merchant-text-tertiary">Searched Results</p>

      {results.flatMap((business, index) => {
        const items = [
          <BusinessResultItem
            key={business.id}
            name={business.name}
            address={business.address}
            onSelect={() => onSelect(business)}
          />,
        ];

        if (index < results.length - 1) {
          items.push(
            <div
              key={`${business.id}-divider`}
              className="h-px w-full bg-merchant-border-strong"
              aria-hidden="true"
            />,
          );
        }

        return items;
      })}
    </div>
  );
});

BusinessSearchResults.displayName = 'BusinessSearchResults';

export default BusinessSearchResults;
